import React from 'react'
import Select from 'react-select'
import CheckboxComponent from '../../../CommonComponents/CheckboxComponent'
import ThreeStateToggleButton from '../../../CommonComponents/ThreeStateToggleButton'
import { Panel } from 'rsuite';

const CheckAcceptance = ({ masterDetails, isMergeMaster }) => {
    const paymentTermsOptions = [...Array(91)].map((_, i) => i);
    const PanelHeader = (headerText) => {
        return (
            <h4 className={`mb-0 ${isMergeMaster ? 'd-none' : 'p-0'}`}> {headerText} </h4>
        )
    }
    return (
        <Panel header={PanelHeader("Check Acceptance Information")} className="supply-card-acceptance mt-0" collapsible bordered>
            <div className="card supply-check-acceptance mt-0 pt-0 border-0">
                <div className="card-content p-0">
                    <div className="item">
                        <h4 className='fw-bold text-black toggle-item-text mb-0'>Do they accept Check Payments?</h4>
                        <ThreeStateToggleButton isDisabled={true} checked={masterDetails?.payment?.isAcceptCheckPayments || false} />
                    </div>

                    {
                        (masterDetails?.payment?.isAcceptCheckPayments || false) && (
                            <>
                                <div className='item'>
                                    <CheckboxComponent
                                        label='Check payment address varies from company address'
                                        disabled={true}
                                        checked={masterDetails?.payment?.isAcceptPaymentAddressFromCompanyAddress || false}
                                    />
                                </div>
                                <div className="item">
                                    <h4 className="item-name mb-0">Address Line1:</h4>
                                    <input
                                        type="text"
                                        className="search-input"
                                        disabled={true}
                                        value={masterDetails?.payment?.checkAddress1 || ''}
                                    />
                                </div>
                                <div className="item">
                                    <h4 className="item-name mb-0">Address Line2:</h4>
                                    <input
                                        type="text"
                                        className="search-input"
                                        disabled={true}
                                        value={masterDetails?.payment?.checkAddress2 || ''}
                                    />
                                </div>
                                <div className="item">
                                    <h4 className="item-name mb-0">City:</h4>
                                    <input
                                        type="text"
                                        className="search-input"
                                        disabled={true}
                                        value={masterDetails?.payment?.checkCity || ''}
                                    />
                                </div>
                                <div className="item">
                                    <h4 className="item-name mb-0">State:</h4>
                                    <input
                                        type="text"
                                        className="search-input"
                                        disabled={true}
                                        value={masterDetails?.payment?.checkState || ''}
                                    />
                                </div>
                                <div className="item">
                                    <h4 className="item-name mb-0">Country:</h4>
                                    <input
                                        type="text"
                                        className="search-input"
                                        disabled={true}
                                        value={masterDetails?.payment?.checkCountry || ''}
                                    />
                                </div>
                                <div className="item">
                                    <h4 className="item-name mb-0">Zip:</h4>
                                    <input
                                        type="text"
                                        className="search-input check-zip-input"
                                        disabled={true}
                                        value={masterDetails?.payment?.checkZip || ''}
                                    />
                                </div>
                                <div className="item">
                                    <h4 className='fw-bold text-black toggle-item-text mb-0'>Cash Payment Terms</h4>
                                    <ThreeStateToggleButton isDisabled={true} checked={masterDetails?.payment?.isAcceptCashPaymentTerms} />
                                </div>

                                {
                                    masterDetails?.payment?.isAcceptCashPaymentTerms && (
                                        <div className="item payment-terms">
                                            <div className='d-flex w-100 flex-column'>
                                                <h4 className='text-black fw-normal'>Payment Terms:</h4>
                                                <Select
                                                    className="cash-payment-terms-selector ms-0 w-100 h4 mb-0"
                                                    placeholder="Select..."
                                                    options={
                                                        paymentTermsOptions.map((element) => (
                                                            {
                                                                label: element === 0 ? 'Upon Receipt' : element + (element === 1 ? ' Day' : ' Days'),
                                                                value: element === 0 ? 'Upon Receipt' : element + (element === 1 ? ' Day' : ' Days')
                                                            }
                                                        ))
                                                    }
                                                    value={{
                                                        label: masterDetails?.payment?.cashPaymentTermsValue || '',
                                                        value: masterDetails?.payment?.cashPaymentTermsValue || '',
                                                    }}
                                                    isDisabled={true}
                                                />
                                            </div>
                                        </div>
                                    )
                                }

                                <div className="item">
                                    <h4 className='fw-bold text-black toggle-item-text mb-0'>Do they offer cash Discount?</h4>
                                    <ThreeStateToggleButton isDisabled={true} checked={masterDetails?.payment?.isAcceptCashDiscount} />
                                </div>
                                {
                                    masterDetails?.payment?.isAcceptCashDiscount && (
                                        <>
                                            <div className="item cash-discount d-flex flex-column align-items-start">
                                                <h4 className='text-black fw-normal'> Cash Discount: </h4>
                                                <div className='flex processing-fee-dropdown-parent w-100 gap-2 flex-column'>
                                                    <div className='d-flex'>
                                                        <div className='flex processing-fee-dropdown-child flex-grow-1'>
                                                            <Select
                                                                menuMaxHeight={48}
                                                                className="processing-fee-dropdown h4 mb-0"
                                                                options={
                                                                    [
                                                                        {
                                                                            label: '$',
                                                                            value: 'Dollar',
                                                                        },
                                                                        {
                                                                            label: '%',
                                                                            value: 'Percentage',
                                                                        },
                                                                    ]
                                                                }
                                                                value={{
                                                                    label: !masterDetails?.payment?.cashDiscountType ? '%' : masterDetails?.payment?.cashDiscountType === 'Percentage' ? '%' : '$',
                                                                    value: masterDetails?.payment?.cashDiscountType || 'Percentage'
                                                                }}
                                                                isDisabled={true}
                                                            />
                                                            <input
                                                                type="text"
                                                                className="search-input cash-discount-value-input"
                                                                value={masterDetails?.payment?.cashDiscountValue || ''}
                                                                disabled={true}
                                                                placeholder={masterDetails?.payment?.cashDiscountType?.value === 'Dollar' ? '1,234.00' : '12.50'}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )
                                }
                            </>
                        )
                    }
                </div>
            </div>
        </Panel>
    )
}

export default CheckAcceptance